<template>
    <toolbar-option :message="message">
        <template slot="primary">
            <toggle :value="isActive" @input="onActiveInput" />

            <div v-if="isActive">
                <br>

                <slider
                    :values="themeObjectValues"
                    :value="sliderIndex"
                    display-unit="s"
                    show-decimal
                    @input="onInput"
                />
            </div>
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option-slider';

const DEFAULT_DURATION = '0.3';

export default {
    name: 'hover-transition',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Hover Transitions',
            durationIndex: 0,
            isActive: false,
            message: '* Turn on to smoothly transition between default and hover styles. Note that if you add animations to this element, this option should be turned off.',
            tailwindDefinitionProp: 'transition',
        };
    },

    computed: {
        defaultDurationIndex() {
            return this.themeObjectValues.indexOf(DEFAULT_DURATION);
        },
    },

    created() {
        this.durationIndex = this.defaultDurationIndex;
    },

    methods: {
        onActiveInput(isChecked) {
            this.isActive = isChecked;

            if (isChecked) {
                const flexClass = this.addFlexClass({
                    value: this.sliderValue,
                });

                this.onOptionChange(flexClass);
            } else {
                this.removeFlexClass('default');
            }
        },

        onSelectedElement() {
            if (this.flexClass) {
                this.isActive = true;
                this.setSlider();
            } else {
                this.isActive = false;
                this.sliderIndex = this.defaultDurationIndex;
            }
        },
    },
};
</script>
